export const AI_MODELS = ['Veo 3.1 Fast', 'Veo 3.1', 'Veo 3', 'Veo 3 Fast', 'Veo 2','Whisper', 'Gemini 2.5', 'Gemini 3 Pro', 'Hunyuan', 'Mochi' , 'Opensora', 'Wan 2.2'] as const;

export const DEFAULT_MODEL = 'Veo 3.1 Fast' as const;

export type AIModel = typeof AI_MODELS[number];

// Models that are coming soon and not yet available

// Video generation models
export const VIDEO_MODELS: AIModel[] = ['Veo 3.1 Fast', 'Veo 3.1', 'Veo 3 Fast', 'Veo 3', 'Veo 2', 'Hunyuan', 'Mochi', 'Opensora', 'Wan 2.2'];

// Image generation models  
export const IMAGE_MODELS: AIModel[] = ['Gemini 2.5', 'Gemini 3 Pro'];

// Transcription models
export const TRANSCRIPTION_MODELS: AIModel[] = ['Whisper'];

// Models that support multiple image uploads (up to 3 images)
export const MULTI_IMAGE_SUPPORT_MODELS: AIModel[] = ['Veo 3.1', 'Veo 3.1 Fast'];

// Helper function to check if a model supports multiple images
export const supportsMultipleImages = (model: AIModel): boolean => {
  return MULTI_IMAGE_SUPPORT_MODELS.includes(model);
};

export const FORBIDDEN_WORDS = [
  // Violence / Harm
  "kill", "murder", "stab", "shoot", "attack", "assault", "hit", "beat",
  "bomb", "explode", "torture", "poison", "slash", "choke", "hang",
  "injure", "blood", "weapon",

  // Derogatory / Hate Speech
  "racist", "slurs", "insult", "idiot", "dumb", "loser", "moron", "hateful",
  "attack", "bully", "degrade", "shame",

  // Substance Abuse
  "drugs", "cocaine", "heroin", "meth", "marijuana", "alcohol", "smoking",
  "tobacco", "abuse", "overdose",

  // Self-harm / Suicide
  "suicide", "self-harm", "cut", "hang", "overdose", "kill myself", "choke", "drown",

  // Absurd / Nonsense / Unsafe
  "monster", "demon", "zombie", "ghost", "alien invasion", "apocalypse",
  "disaster", "cursed", "possessed", "freak", "mutant"
];
